import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
export function AppRouter() {
  return <BrowserRouter data-id="element-51">
      <Routes data-id="element-52">
        <Route path="/*" element={<App data-id="element-54" />} data-id="element-53" />
      </Routes>
    </BrowserRouter>;
}